import posthogService from "../services/posthogService";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getValidatedPostHogDeviceId(): string | null {
  try {
    const deviceId = posthogService.getDeviceId();
    if (typeof deviceId !== "string" || deviceId.length !== 36
      || !UUID_PATTERN.test(deviceId)) return null;
    return deviceId;
  } catch {
    // Optional attribution must never prevent a visit or login request.
    return null;
  }
}
